<template>
  <div class="h-auto ml-0 w-full lg:mr-3 mt-2 p-3 pt-0">
    <el-tabs type="border-card" v-model="active">
      <el-tab-pane
        v-for="(tab, index) in filteredTabs"
        :key="index"
        :label="tab.name"
        :name="tab.name"
      >
        <mine v-if="index === 0"></mine>
        <team v-if="index === 1"></team>
        <claim-management v-if="index == 2" :name="tab.name"></claim-management>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import mine from "@/components/claims/mine.vue";
import team from "@/components/claims/team.vue";
import ClaimManagement from "../employees/tabs/claimManagement.vue";
import { mapGetters } from "vuex";

export default {
  name: "ClaimsSetupsTabs",
  props: ["setup", "activeClaimTab"],
  components: {
    mine,
    team,
    ClaimManagement,
  },

  data() {
    return {
      selectedTab: "Claim Types",
      teamKey: 0,
      mineKey: 1,
      isApproved: true,
      isDeclined: false,
      active: "Self",
      tabs: [
        {
          name: "Self",
          route: "my-claims",
        },
        {
          name: "Team",
          route: "team-claims",
        },
        {
          name: "Claim Management",
          route: "claim-management",
        },
      ],
    };
  },
  created() {
    this.active = this.activeClaimTab;
  },
  computed: {
    ...mapGetters(["getUserRole"]),
    filteredTabs() {
      if (this.getUserRole.toLowerCase() === "hrmanager") {
        return this.tabs;
      } else {
        return this.tabs.filter((tab) => tab.name !== "Claim Management");
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  watch: {},
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
</style>
